import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, FormGroup, Label, Input } from "reactstrap";
import { kecamatanOptions } from './OptionsFilter';

const EditModal = ({ isOpen, toggle, item, onSubmit, desaOptions, onKecamatanChange, errors = {} }) => {
  const [form, setForm] = useState({
    tanggalDiterima: "",
    nomorSurat: "",
    tanggalSurat: "",
    namaPemohonLembagaPengusul: "",
    namaKepalaKeluarga: "",
    nomorKK: "",
    nik: "",
    alamatPemohon: "",
    perihal: "",
    disposisiDari: "",
    diteruskanKepada: "",
    catatan: "",
    status: "",
    kecamatan: "",
    desaKelurahan: "",
    file: null
  });
  const [submitting, setSubmitting] = useState(false);
  const [localDesaOptions, setLocalDesaOptions] = useState([]);

  useEffect(() => {
    if (item && isOpen) {
      setForm({
        tanggalDiterima: item.tanggalDiterima || "",
        nomorSurat: item.nomorSurat || "",
        tanggalSurat: item.tanggalSurat || "",
        namaPemohonLembagaPengusul: item.namaPemohonLembagaPengusul || "",
        namaKepalaKeluarga: item.namaKepalaKeluarga || "",
        nomorKK: item.nomorKK || "",
        nik: item.nik || "",
        alamatPemohon: item.alamatPemohon || "",
        perihal: item.perihal || "",
        disposisiDari: item.disposisiDari || "",
        diteruskanKepada: item.diteruskanKepada || "",
        catatan: item.catatan || "",
        status: item.status || "Diproses",
        kecamatan: item.kecamatan || "",
        desaKelurahan: item.desaKelurahan || "",
        file: null
      });

      // Set local desa options berdasarkan kecamatan item
      if (item.kecamatan && kecamatanOptions[item.kecamatan]) {
        setLocalDesaOptions(kecamatanOptions[item.kecamatan]);
      } else {
        setLocalDesaOptions([]);
      }
    }
  }, [item, isOpen]);

  // Update local desa options ketika kecamatan berubah
  useEffect(() => {
    if (form.kecamatan && kecamatanOptions[form.kecamatan]) {
      setLocalDesaOptions(kecamatanOptions[form.kecamatan]);
    } else {
      setLocalDesaOptions([]);
    }
  }, [form.kecamatan]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    
    if (name === "file") {
      setForm((prev) => ({ ...prev, file: files && files[0] ? files[0] : null }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
      
      // Jika kecamatan berubah, reset desaKelurahan dan panggil callback
      if (name === "kecamatan") {
        setForm(prev => ({ ...prev, desaKelurahan: "" }));
        if (onKecamatanChange) {
          onKecamatanChange(value);
        }
      }
    }
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      await onSubmit(form);
      toggle();
    } finally {
      setSubmitting(false);
    }
  };

  // Gunakan localDesaOptions untuk dropdown desa
  const currentDesaOptions = form.kecamatan ? localDesaOptions : desaOptions || [];

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xs" style={{ paddingTop: "40px" }} backdrop="static">
      <ModalHeader toggle={toggle}>Edit Register Usulan</ModalHeader>
      <ModalBody>
        <Row>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Tanggal Terima</Label>
              <Input 
                type="date" 
                name="tanggalDiterima" 
                value={form.tanggalDiterima} 
                onChange={handleChange} 
              />
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Nomor Surat</Label>
              <Input 
              type="text"
                name="nomorSurat" 
                value={form.nomorSurat} 
                onChange={handleChange} 
              />
            </FormGroup>
          </Col>
           <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Tanggal Surat</Label>
              <Input 
                type="date" 
                name="tanggalSurat" 
                value={form.tanggalSurat} 
                onChange={handleChange} 
              />
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Nama Pemohon / Lembaga Pengusul</Label>
              <Input 
                name="namaPemohonLembagaPengusul" 
                value={form.namaPemohonLembagaPengusul} 
                onChange={handleChange} 
              />
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Nama Kepala Keluarga</Label>
              <Input 
                name="namaKepalaKeluarga" 
                value={form.namaKepalaKeluarga} 
                onChange={handleChange} 
              />
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Nomor KK</Label>
              <Input 
                name="nomorKK" 
                value={form.nomorKK} 
                onChange={handleChange} 
              />
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>NIK</Label>
              <Input 
                name="nik" 
                value={form.nik} 
                onChange={handleChange} 
              />
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Alamat Pemohon</Label>
              <Input 
                name="alamatPemohon" 
                value={form.alamatPemohon} 
                onChange={handleChange} 
              />
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
                         <Label>Perihal / Usulan</Label>
                         <Input type="select" name="perihal" value={form.perihal} onChange={handleChange} >
                                           <option value="">Pilih</option>
                     <option value="Rehab Rumah Tidak Layak Huni">Rehabilitasi Rumah Tidak Layak Huni</option>
                     <option value="Pembangunan Rumah Layak Huni">Pembangunan Rumah Layak Huni</option>
                     <option value="Meteran Listrik 900 VA">Meteran Listrik 900 VA</option>
                    
                         </Input>
                       </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Disposisi Dari</Label>
              <Input 
                name="disposisiDari" 
                value={form.disposisiDari} 
                onChange={handleChange} 
              />
            </FormGroup>
          </Col>
                       <Col md={6} className="mb-3">
                            <FormGroup>
                              <Label>Diteruskan Kepada</Label>
                              <Input 
                                name="diteruskanKepada" 
                                value={form.diteruskanKepada} 
                                onChange={handleChange}
                              />
                            </FormGroup>
                          </Col>
          {/* Field Kecamatan */}
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label for="kecamatan">Kecamatan</Label>
              <Input 
                type="select" 
                name="kecamatan" 
                id="kecamatan" 
                value={form.kecamatan || ""} 
                onChange={handleChange} 
                className={errors.kecamatan ? "is-invalid" : ""}
              >
                <option value="">Pilih Kecamatan</option>
                {Object.keys(kecamatanOptions).map((kec) => (
                  <option key={kec} value={kec}>
                    {kec}
                  </option>
                ))}
              </Input>
              {errors.kecamatan && <div className="invalid-feedback">{errors.kecamatan}</div>}
            </FormGroup>
          </Col>
          
          {/* Field Desa/Kelurahan */}
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label for="desaKelurahan">Desa/Kelurahan</Label>
              <Input 
                type="select" 
                name="desaKelurahan" 
                id="desaKelurahan" 
                value={form.desaKelurahan || ""} 
                onChange={handleChange} 
                disabled={!form.kecamatan}
                className={errors.desaKelurahan ? "is-invalid" : ""}
              >
                <option value="">Pilih Desa/Kelurahan</option>
                {currentDesaOptions.map((desa) => (
                  <option key={desa} value={desa}>
                    {desa}
                  </option>
                ))}
              </Input>
              {errors.desaKelurahan && <div className="invalid-feedback">{errors.desaKelurahan}</div>}
            </FormGroup>
          </Col>
          
          <Col md={12} className="mb-3">
            <FormGroup>
              <Label>Catatan / Tindak Lanjut</Label>
              <Input 
                type="textarea" 
                name="catatan" 
                value={form.catatan} 
                onChange={handleChange} 
              />
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Status</Label>
              <Input 
                type="select" 
                name="status" 
                value={form.status} 
                onChange={handleChange}
              >
                <option value="Diproses">Diproses</option>
                <option value="Disetujui">Disetujui</option>
                <option value="Ditolak">Ditolak</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md={6} className="mb-3">
            <FormGroup>
              <Label>Ganti File (Opsional)</Label>
              <Input 
                type="file" 
                name="file" 
                accept="application/pdf" 
                onChange={handleChange} 
              />
              {item?.file && (
                <small className="form-text text-muted">
                  File saat ini: {item.file}
                </small>
              )}
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={submitting}>
          Batal
        </Button>
        <Button color="primary" onClick={handleSubmit} disabled={submitting}>
          {submitting ? 'Menyimpan...' : 'Simpan Perubahan'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditModal;